// Helpers de formato de estados de conversación / mensaje WhatsApp.
// Centraliza mapeos para que la UI sea consistente.

const CONV_STATUS = {
  abierta: { label: 'Abierta', badge: 'success' },
  cerrada: { label: 'Cerrada', badge: 'secondary' },
  eliminada: { label: 'Eliminada', badge: 'dark' }
};

const MSG_STATUS = {
  sent: { label: 'Enviado', icon: 'sent' },
  delivered: { label: 'Entregado', icon: 'delivered' },
  read: { label: 'Leído', icon: 'read' },
  failed: { label: 'Fallido', icon: 'failed' },
  pending: { label: 'Pendiente', icon: 'pending' }
};

export const formatConversationStatus = (status) => CONV_STATUS[status] || { label: status || '', badge: 'secondary' };
export const formatMessageStatus = (status) => MSG_STATUS[status] || { label: status || '', icon: null };
